app.mediator.registerModule(MODULE_NAME__NEWS, function (app) {

    // "Private class" variables
    var helpers = app.helpers.funcs;
    var fullPageBuildAnimationTimeout;
    var fullPageBuildAnimationClass = 'full-page-build-animation';

    return {

        $rootElem: null,
        appendingIsLocked: false,
        newsItemSelector: '.news-item-col-wrap',
        activeNewsItemModifier: '.active',
        itemsData: [],

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            var scope = this;
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                app.mediator.notify(EVENT_NAME__NEWS__PREINIT);
                setTimeout(function () {
                    scope.init();
                }, 100);
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$rootElem = $('.wrap-news-items > .container > .row');

            if (this.$rootElem.length) {
                this.addDomListeners();
                this.addMediatorListeners();
                this.respondToScrollAndResize();
            }

            // Equalise the div heights
            this.equaliseDivHeights();

            // And also run it in response to a screen resize.
            app.globalEventRegistry.addListener('resize', helpers.throttler(function () {
                scope.equaliseDivHeights();
            }, 200));

            app.mediator.notify(EVENT_NAME__NEWS__INITIATED);
        },

        //==========================================================xdiv2====
        // DOM listeners
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            app.globalEventRegistry.addListener('scroll', function () {
                scope.respondToScrollAndResize();
            });
            app.globalEventRegistry.addListener('resize', function () {
                scope.respondToScrollAndResize();
            });
        },

        //==========================================================xdiv2====
        // Mediator listeners
        //===================================================================

        addMediatorListeners: function () {
            // None yet
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        equaliseDivHeights: function () {
            var itemsPerRowPerBreakpoint = {};
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.xs] = 1;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.sm] = 2;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.md] = 3;
            itemsPerRowPerBreakpoint[app.helpers.screenBreakpoints.lg] = 3;
            helpers.equaliseDivHeights(this.$rootElem.find(this.newsItemSelector), itemsPerRowPerBreakpoint);
        },

        // The height that a this.newsItemSelector is assumed to be,
        // if we can't determine it by inspecting one on the page.
        // We typically call this method when no this.newsItemSelector
        // divs have been appended yet.
        approximateNewsBlockHeight: function () {
            var scope = this;
            var breakpoint = helpers.getScreenSize();
            var value;
            switch (breakpoint) {
                case app.helpers.screenBreakpoints.xs:
                    value = (scope.$rootElem.width() / 16) * 9;
                    break;
                default:
                    value = ((scope.$rootElem.width() / 2) / 16) * 9;
            }
            return value;
        },

        //----------------------------------------------xdiv3----
        // Infinite scroll: General
        //-------------------------------------------------------

        // n = The number of items to append and reveal even if there is no whitespace available.
        setItemsData: function (itemsData, callUpdate, n) {
            var scope = this;
            callUpdate = typeof callUpdate !== 'undefined' ? callUpdate : false;
            n = typeof n !== 'undefined' ? n : false;
            this.itemsData = itemsData;
            if (callUpdate) {
                setTimeout(function () {
                    scope.appendAndRevealItemsToFillAvailableSpace(n);
                }, 300);
            }
        },

        getNumItemsShown: function () {
            return this.$rootElem.find(this.newsItemSelector + this.activeNewsItemModifier).length;
        },

        numToLoadAtOnce: function () {
            var breakpoint = helpers.getScreenSize();
            switch (breakpoint) {
                case app.helpers.screenBreakpoints.xs:
                    return 1;
                    break;
                case app.helpers.screenBreakpoints.sm:
                    return 2;
                    break;
                default:
                    return 3;
            }
        },

        respondToScrollAndResize: function () {
            var scope = this;
            if (this.pastBitePointForAppending() && (!this.appendingIsLocked)) {
                scope.appendXMoreItems();
            }
            this.revealAllItemsPastRevealBitePoint();
            this.equaliseDivHeights();
        },

        getScreenReaderItemLabel: function (itemData) {
            var linkLabel = itemData.title;
            var descrArray = itemData.description.split('.');

            // If we have at least once full sentence, then append the first full
            // sentence to the screen reader's description.
            if (descrArray.length > 1) {
                linkLabel = linkLabel + '. ' + descrArray[0];
            }
            return linkLabel;
        },

        getTemplateElem: function (itemData) {
            var n = this.getNumItemsShown();
            var itemInner = helpers.getTemplateHtml($('#page-news-item-template').get(0)).querySelectorAll('.template-inner');
            var $templateHtml = $(itemInner);
            var $itemImage = $templateHtml.find('.actual-image');
            var $itemImageDiv = $templateHtml.find('.item-image');
            var screenReaderLabel = this.getScreenReaderItemLabel(itemData);
            $templateHtml.find('a')
                .attr('href', itemData.url)
                .attr('aria-label', screenReaderLabel)
                .attr('id', 'newsArticle' + n);
            $templateHtml.find('.news-preview-description').text(itemData.description);
            $templateHtml.find('h5').text(itemData.title);
            $itemImage.attr('src', itemData.imageUrl + '?width=350');
            $itemImageDiv.css({
                backgroundImage: 'url(' + itemData.imageUrl + '?width=350)'
            });
            $itemImageDiv.find('.item-image').attr('src', itemData.imageUrl).attr('alt', itemData.imageAlt);

            return $templateHtml;
        },

        loadImagesThen: function (itemsData, callback) {

            var attemptCallback = function () {
                var allImagesHaveLoaded = itemsData.every(function (itemData) {
                    return itemData.loaded === true;
                });
                if (allImagesHaveLoaded && typeof callback == 'function') {
                    callback.call();
                }
            };

            itemsData.forEach(function (itemData) {
                itemData.loaded = false;
                if (itemData.hasOwnProperty('imageUrl') && itemData.imageUrl) {
                    $('<img/>').attr('src', itemData.imageUrl + '?width=350').on('load', function () {
                        itemData.loaded = true;
                        attemptCallback();
                        $(this).remove();
                    })
                } else {
                    itemData.loaded = true;
                    attemptCallback();
                }
            });
        },

        // return true if the top of the window is past the bottom of the $rootElem.
        pastBitePoint: function () {
            var topWindow = $(window).scrollTop();
            var bottomRoot = this.$rootElem.offset().top + this.$rootElem.outerHeight();
            var relativeTop = topWindow + (window.innerHeight / 1.2);
            return relativeTop > bottomRoot;
        },

        //----------------------------------------------xdiv3----
        // Infinite scroll: Append
        //-------------------------------------------------------

        getNumberItemsAppended: function () {
            return this.$rootElem.find(this.newsItemSelector).length;
        },

        // The number of entry items to append into the news list upon each scroll event
        // that successfully bites.
        getNumberToAppendAtOnce: function () {
            return 6;
        },

        // return true if the top of the window is near the bottom of the $rootElem.
        pastBitePointForAppending: function () {
            var topWindow = $(window).scrollTop();
            var bottomRoot = this.$rootElem.offset().top + this.$rootElem.outerHeight();
            var relativeTop = topWindow + window.innerHeight;
            var fallbackHeight = this.approximateNewsBlockHeight();
            var heightOfOneBlock = this.$rootElem.find(this.newsItemSelector).height() || fallbackHeight;
            return relativeTop >= bottomRoot - heightOfOneBlock * 2;
        },

        appendItem: function (itemData) {
            var scope = this;
            var itemHtml = this.getTemplateElem(itemData).html();
            var $itemHtml = $(itemHtml);
            app.ui.uiPlugins.btn.init($itemHtml);
            $itemHtml.appendTo(this.$rootElem);
        },

        appendItems: function (itemsData) {
            var scope = this;
            itemsData.forEach(function (itemData) {
                scope.appendItem(itemData);
            });
        },

        appendXMoreItems: function (numberToAppendAtOnce) {
            var scope = this;
            var numberToAppendAtOnce = typeof numberToAppendAtOnce !== 'undefined' ?
                numberToAppendAtOnce : this.getNumberToAppendAtOnce();
            this.appendingIsLocked = true;
            var numberItemsShown = this.getNumberItemsAppended();
            var itemsData = this.itemsData.slice(numberItemsShown, numberItemsShown + numberToAppendAtOnce);
            scope.appendItems(itemsData);
            scope.appendingIsLocked = false;
        },

        //----------------------------------------------xdiv3----
        // Infinite scroll: Reveal
        //-------------------------------------------------------

        getNumberToRevealAtOnce: function () {
            var breakpoint = helpers.getScreenSize();
            switch (breakpoint) {
                case app.helpers.screenBreakpoints.xs:
                    return 1;
                case app.helpers.screenBreakpoints.sm:
                    return 2;
                default:
                    return 3;
            }
        },

        revealAllAppendedItems: function () {
            this.$rootElem.find(this.newsItemSelector).addClass(this.activeNewsItemModifier.replace('.', ''));
        },

        // Reveals all gallery div items that have been appended to the page,
        // which are also above the fold.
        revealAllItemsPastRevealBitePoint: function () {
            var scope = this;
            var $items = this.$rootElem.find(this.newsItemSelector).not(this.activeNewsItemModifier.replace('.', ''));
            if (!$items.length) return;
            var bottomOfWindow = $(window).scrollTop() + $(window).height();
            var fallbackHeight = this.approximateNewsBlockHeight();
            var breakpoint = helpers.getScreenSize();
            var biteDistanceFactor = 1;
            if (breakpoint == app.helpers.screenBreakpoints.xs) biteDistanceFactor = 1.2;
            var chunkedItems = app.helpers.funcs.arrayChunk($items.toArray(), this.getNumberToRevealAtOnce());
            chunkedItems.forEach(function (chunk) {
                var revealItems = false;
                chunk.forEach(function (item) {
                    var $item = $(item);
                    var itemHeight = $item.outerHeight() || fallbackHeight;
                    var bottomOfItem = $item.offset().top + itemHeight;
                    if (bottomOfWindow >= (bottomOfItem - ((itemHeight / 1.5) * biteDistanceFactor))) {
                        revealItems = true;
                    }
                });
                if (revealItems) {
                    chunk.forEach(function (item) {
                        var $item = $(item);
                        $item.addClass(scope.activeNewsItemModifier.replace('.', ''));
                    });
                }
            });

        },

        //----------------------------------------------xdiv3----
        // Infinite scroll: Append and Reveal
        //-------------------------------------------------------

        appendAndRevealItemsToFillAvailableSpace: function (numberOfItemsToAddEvenIfNoSpace) {

            numberOfItemsToAddEvenIfNoSpace = typeof numberOfItemsToAddEvenIfNoSpace !== 'undefined' ?
                numberOfItemsToAddEvenIfNoSpace : 0;
            if (numberOfItemsToAddEvenIfNoSpace === true) numberOfItemsToAddEvenIfNoSpace = this.getNumberToAppendAtOnce();
            var numberToRevealAtOnce = typeof numberToRevealOnce !== 'undefined' ?
                numberToRevealAtOnce : this.getNumberToRevealAtOnce();
            var scope = this;

            clearTimeout(fullPageBuildAnimationTimeout);
            scope.$rootElem.addClass(fullPageBuildAnimationClass);

            var shouldKeepLooping = function () {
                var menuHeight = $('.mod-main-header').height();
                var mainHeight = $('#main').height();
                var bodyHeight = $('body').height();
                var numberItems = scope.getNumberItemsAppended();
                var spaceAvailable = bodyHeight - (menuHeight + mainHeight);
                var shouldAppendAndReveal = spaceAvailable > 0;
                return shouldAppendAndReveal;
            };

            // Append an abitrary amount of items (which will grow the height of the document).
            if (numberOfItemsToAddEvenIfNoSpace) {
                scope.appendXMoreItems(numberOfItemsToAddEvenIfNoSpace);
            }

            var shouldAddSomeItems = shouldKeepLooping();
            var i = 0;
            while (shouldAddSomeItems) {
                // There is whitespace available at the end of the document on page load.
                // Append items until that whitespace is filled, so that the page 'looks right',
                // and the user still has the ability to scroll so that they can reveal more.
                scope.appendXMoreItems(numberToRevealAtOnce);
                shouldAddSomeItems = shouldKeepLooping(i);
                if (i > 20) break;
                i++;
            }

            // Reveal all items that are on the page, above the fold
            scope.revealAllItemsPastRevealBitePoint();

            fullPageBuildAnimationTimeout = setTimeout(function () {
                scope.$rootElem.removeClass(fullPageBuildAnimationClass);
            }, 1000);
        }
    }
});
